<!--
 * @Author: your name
 * @Date: 2021-07-20 16:31:02
 * @LastEditTime: 2021-12-17 17:54:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\indexes\add\index.vue
-->
<template>
  <div>
    <detail />
  </div>
</template>
<script>
import detail from './components/details';
export default {
  name: 'SettingIndexesConfigListAdd',
  components: {
    detail,
  },
};
</script>
